import React from 'react';
import { Modal, StyleSheet, Pressable, Dimensions } from 'react-native';
import { YStack } from '@tamagui/stacks';
import { X as XIcon } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import AuthenticatedImage from '@/components/AuthenticatedImage';

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

type PhotoViewerModalProps = {
  visible: boolean;
  imageUri: string;
  onClose: () => void;
};

const PhotoViewerModal = React.memo<PhotoViewerModalProps>(({ visible, imageUri, onClose }) => {
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <YStack style={styles.container}>
        <Pressable style={styles.closeButton} onPress={onClose}>
          <YStack style={styles.closeButtonInner}>
            <XIcon size={24} color={COLORS.WHITE} />
          </YStack>
        </Pressable>
        
        <Pressable style={styles.backdrop} onPress={onClose}>
          <AuthenticatedImage 
            uri={imageUri}
            style={styles.image}
            resizeMode="contain"
          />
        </Pressable>
      </YStack>
    </Modal>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backdrop: {
    flex: 1,
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
  },
  closeButton: {
    position: 'absolute',
    top: 50,
    right: 20,
    zIndex: 10,
  },
  closeButtonInner: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

PhotoViewerModal.displayName = 'PhotoViewerModal';

export default PhotoViewerModal;

